import React from 'react';
import "react-perfect-scrollbar/dist/css/styles.css";
import ApiContentComponent from '../component/api-content';
import SiteLoader from '../../../shared/components/loader/siteLoader';
import NoData from '../../../shared/components/no-data/no-data';
import httpService from '../../../shared/services/http.services';
import { API_CONFIG } from '../../../shared/constants/api';
import '../component/apiStyle.scss';

class ApiContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            innerWidth: window.innerWidth,
            isLoading: true,
            content: null,
        };
    }

    componentDidMount() {
        const endPoint = this.props.location.hash.split("#")[1];
        if (window.innerWidth >= 1200) {
            window.addEventListener('scroll', this.handleScroll);
        }
        this.getApiPageContent(endPoint);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.hash !== prevProps.location.hash) {
            const endPoint = this.props.location.hash.split("#")[1];
            this.getApiPageContent(endPoint);
        }
    }

    /**
     * getApiPageContent method is used to get api content for career page
     * it sets data as well and loading false
     */
    getApiPageContent = async (endPoint) => {
        try {
            const data = await httpService.get(`${API_CONFIG.path.apiContent}${endPoint}`);
            if (data && data.acf) {
                this.setState({
                    isLoading: false,
                    content: data.acf,
                });
            }

        } catch (error) {
            console.log(error);
            this.setState({
                isLoading: false,
                content: null,
            });
        }
    };

    componentWillUnmount() {
        if (window.innerWidth >= 1200) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }

    /**
     * handleScroll method is used to make job summary stick and remove stick class
     * it will take the offset of its upper div and below
     */
    handleScroll = (event) => {
        const sidebar = document.getElementById('side-nav');
        const sidebarClone = document.getElementById('side-nav-clone');
        const documentWrapper = document.getElementById('content-box');
        const footer = document.getElementById('site-footer');

        let padding = -40;
        if (
            sidebar &&
            window.scrollY > documentWrapper.offsetTop
            && window.scrollY < documentWrapper.clientHeight
        ) {
            sidebar.classList.add('is-fixed');
            sidebar.style.top = `${100}px`;
        } else {
            if (sidebar) {
                sidebar.style.top = `${0}px`;
                sidebar.classList.remove('is-fixed');
            }
        }
        if (
            sidebar && footer &&
            window.scrollY + sidebarClone.offsetHeight + 100 > footer.offsetTop
        ) {
            sidebar.style.top = `${(window.scrollY + sidebarClone.offsetHeight - (footer.offsetTop + padding)) *
                -1
                }px`;
        }
    };
    render() {
        return (
            <>
                { this.state.isLoading &&
                    <div className="loadingWrap" >
                        <SiteLoader />
                    </div>   
                }
                { !this.state.isLoading && this.state.content &&
                    <ApiContentComponent
                        content={ this.state.content }
                        id={ this.props.match.params.id }
                        innerWidth={ this.state.innerWidth }
                    />
                }
                {
                    !this.state.isLoading && !this.state.content && <NoData text="No data found" />
                }

            </>
        );
    }
}


export default ApiContent;